<app-resp-popup-title>
  <i class="fas fa-receipt fa-fw"></i>
  <span i18n="@@WawiAPI_OrderSelect_DialogTitle">Select an order</span>
</app-resp-popup-title>
<app-resp-popup-content>
  <div class="container-dialog">
    <div class="container-filter">
      @if (filterForm) {
        <form [formGroup]="filterForm"
          style="display: flex; justify-content: space-evenly; align-items: baseline; margin-bottom: 1rem;">
          <div style="margin-right: 3rem;">
            <mat-tab-group (selectedTabChange)="onSelectedTabChange($event.index)">
              <mat-tab label="Number" i18n-label="@@WawiAPI_OrderSelect_Filter_HeaderNumber">
                <table class="table-numbertype">
                  <tr>
                    <td>
                      <input name="currentNumberType" id="radio_currentNumberType_sammelNr" type="radio" class="cst-radio"
                        formControlName="currentNumberType" [value]="0" />
                        <label for="radio_sammelNr" i18n="@@WawiAPI_OrderSelect_Filter_LabelSammelNr">Collection
                      No.</label>
                      </td>
                      @if (currentNumberType == 0) {
                        <td>
                          <div style="display: inline-block; width: 130px;">
                            <frm-text type="number" formControlName="sammelNr"></frm-text>
                          </div>
                          <div style="display: inline-block; width: 70px;">
                      <frm-dropdown [dropdownType]="DropdownType.DropDownList" i18n-label="
                                    @@WawiAPI_OrderSelect_Filter_LabelSammelNrYear" label="Year"
                              formControlName="sammelNrJahr" [items]="sammelNrYearItems"
                            [defaultItem]="{ label: '- -', value: undefined }"></frm-dropdown>
                          </div>
                          <div style="display: inline-block; width: 200px;">
                            <frm-wawi-belart-select i18n-label="@@WawiAPI_OrderSelect_Filter_LabelBelegart"
                              label="Receipt Type" formControlName="belegArt"
                              [defaultItem]="{ label: '- -', value: undefined }"
                            [include]="includedBelegArten"></frm-wawi-belart-select>
                          </div>
                        </td>
                      }
                    </tr>
                    <tr>
                      <td>
                        <input name="currentNumberType" id="radio_currentNumberType_belegNr" type="radio" class="cst-radio"
                          [value]="1" formControlName="currentNumberType" />
                          <label for="radio_belegNr" i18n="@@WawiAPI_OrderSelect_Filter_LabelBelegNr">Receipt
                      No.</label>
                        </td>
                        @if (currentNumberType == 1) {
                          <td>
                            <div style="display: inline-block; width: 400px;">
                              <frm-text formControlName="belegNr"></frm-text>
                            </div>
                          </td>
                        }
                      </tr>
                    </table>
                  </mat-tab>
                  <mat-tab label="Address" i18n-label="@@WawiAPI_OrderSelect_Filter_HeaderAddress">
                    <table style="width: 100%;">
                      <tr>
                        <td style="width: 300px; max-width: 300px;">
                          <frm-wawi-address-select formControlName="addressID"></frm-wawi-address-select>
                        </td>
                        <td style="width: 200px; max-width: 200px;">
                          <frm-wawi-belart-select i18n-label="@@WawiAPI_OrderSelect_Filter_LabelBelegart" label="Receipt Type"
                            formControlName="belegArt" [defaultItem]="{ label: '- -', value: undefined }"
                          [include]="includedBelegArten"></frm-wawi-belart-select>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <frm-daterange-picker orientation="horizontal" [formGroup]="filterForm"
                            formControlNameRangeBegin="dateRangeBegin" formControlNameRangeEnd="dateRangeEnd">
                          </frm-daterange-picker>
                        </td>
                      </tr>
                    </table>
                  </mat-tab>
                  <mat-tab label="Type" i18n-label="@@WawiAPI_OrderSelect_Filter_HeaderReceiptType">
                    <table>
                      <tr>
                        <td>
                          <div style="display: inline-block; width: 250px;">
                            <frm-wawi-belart-select i18n-label="@@WawiAPI_OrderSelect_Filter_LabelBelegart"
                              label="Receipt Type" formControlName="belegArt"
                            [include]="includedBelegArten"></frm-wawi-belart-select>
                          </div>
                          <div style="display: inline-block; width: 250px;">
                            <frm-text i18n-label="@@WawiAPI_OrderSelect_Filter_LabelAnlageNr" label="Anlage-Nr."
                            formControlName="anlageNr"></frm-text>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <frm-daterange-picker orientation="horizontal" [formGroup]="filterForm"
                            formControlNameRangeBegin="dateRangeBegin" formControlNameRangeEnd="dateRangeEnd">
                          </frm-daterange-picker>
                        </td>
                      </tr>
                    </table>
                  </mat-tab>
                </mat-tab-group>
              </div>
              <div style="display: flex; flex-direction: column; width: 10rem;">
                <ctrl-btn matTooltip="Reset the filter" i18n-matTooltip="@@BuClear_Title" (click)="OnClear()"
                  [disabled]="loading" content="Clear" i18n-content="@@BuClear"
                style="width:100%; margin-bottom: 1rem;"></ctrl-btn>
                <!-- <ctrl-btn matTooltip="Start searching" i18n-matTooltip="@@BuSearch_Title" (click)="OnSearch()"
                [disabled]="loading || !filterForm.valid" content="Start searching" i18n-content="@@BuSearch"
              style="width: 100%;"></ctrl-btn> -->
            </div>
          </form>
        }
      </div>
      <div class="container-list">
        <app-list-view [dataSource]="cstDataSource" [columns]="columns" [selectionEnabled]="true"
          [selectionMode]="'single'" [elevated]="false"
        (singleSelectionChanged)="onSelectionChange($event)"></app-list-view>
      </div>
    </div>
  </app-resp-popup-content>
  <app-resp-popup-actions>
    <ctrl-btn type="primary" icon="check" (click)="OnSelect()" content="Select" i18n-content="@@BuSelect"
    [disabled]="loading || !selectedItem"></ctrl-btn>
    <ctrl-btn-cancel (click)="OnCancel()"></ctrl-btn-cancel>
  </app-resp-popup-actions>